/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Recordspagetitle2Inputs */

const zh_learn_recordspagetitle2 = /** @type {(inputs: Learn_Recordspagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作答记录 | StudyOS`)
};

const en_learn_recordspagetitle2 = /** @type {(inputs: Learn_Recordspagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempt Records | StudyOS`)
};

const es_learn_recordspagetitle2 = /** @type {(inputs: Learn_Recordspagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de intentos | StudyOS`)
};

/**
* | output |
* | --- |
* | "Attempt Records \| StudyOS" |
*
* @param {Learn_Recordspagetitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_recordspagetitle2 = /** @type {((inputs?: Learn_Recordspagetitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Recordspagetitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_recordspagetitle2(inputs)
	if (locale === "en") return en_learn_recordspagetitle2(inputs)
	return es_learn_recordspagetitle2(inputs)
});
export { learn_recordspagetitle2 as "learn_recordsPageTitle" }